import React, { useState } from 'react';
import { 
  ZoomIn, ZoomOut, Maximize2, Plus, Grid3X3,
  MousePointer2, Pencil, Link2
} from 'lucide-react';
import { TOOL_MODES } from './useMindMap';

const MindMapToolbar = ({
  onZoomIn,
  onZoomOut,
  onResetView,
  onAddNode,
  snapToGrid,
  onToggleSnap,
  toolMode,
  onSetToolMode,
  drawColor,
  onSetDrawColor,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const colors = ['#6b21a8', '#1d4ed8', '#15803d', '#b45309', '#b91c1c', '#be185d', '#0891b2', '#ffffff'];

  const renderToolButton = (mode, Icon, title) => (
    <button
      key={mode}
      onClick={() => onSetToolMode(mode)}
      className={`p-2 rounded-lg transition-colors ${
        toolMode === mode
          ? 'bg-purple-500/30 text-purple-400'
          : 'hover:bg-white/10 text-zinc-400 hover:text-white'
      }`}
      title={title}
    >
      <Icon size={18} />
    </button>
  );

  return (
    <div className="absolute right-6 top-6 flex flex-row gap-1 p-1.5 bg-[#0f1216] border border-white/10 rounded-xl shadow-xl z-10">
      {/* Select Tool */}
      {renderToolButton(TOOL_MODES.SELECT, MousePointer2, 'Select (V)')}
      
      <div className="w-px bg-white/10 mx-1" />

      {/* Add Node */}
      <button
        onClick={onAddNode}
        className="p-2 rounded-lg hover:bg-white/10 transition-colors text-zinc-400 hover:text-white"
        title="Add new node"
      >
        <Plus size={18} />
      </button>

      {/* Draw Tool */}
      {renderToolButton(TOOL_MODES.DRAW, Pencil, 'Draw (D)')}

      {/* Connector Tool */}
      {renderToolButton(TOOL_MODES.CONNECTOR, Link2, 'Connect nodes (C)')}

      {/* Color Picker for Draw tool */}
      {toolMode === TOOL_MODES.DRAW && (
        <div className="relative">
          <button
            onClick={() => setShowColorPicker(!showColorPicker)}
            className="p-2 rounded-lg hover:bg-white/10 transition-colors"
            title="Drawing color"
          >
            <div 
              className="w-4 h-4 rounded-full border border-white/30"
              style={{ backgroundColor: drawColor }}
            />
          </button>
          {showColorPicker && (
            <div className="absolute top-full mt-2 right-0 p-2 bg-[#0f1216] border border-white/10 rounded-lg shadow-xl">
              <div className="grid grid-cols-4 gap-1">
                {colors.map(color => (
                  <button
                    key={color}
                    onClick={() => {
                      onSetDrawColor(color);
                      setShowColorPicker(false);
                    }}
                    className="w-6 h-6 rounded-md border border-white/20 hover:scale-110 transition-transform"
                    style={{ backgroundColor: color }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="w-px bg-white/10 mx-1" />

      {/* Zoom Controls */}
      <button
        onClick={onZoomIn}
        className="p-2 rounded-lg hover:bg-white/10 transition-colors text-zinc-400 hover:text-white"
        title="Zoom in"
      >
        <ZoomIn size={18} />
      </button>
      <button
        onClick={onZoomOut}
        className="p-2 rounded-lg hover:bg-white/10 transition-colors text-zinc-400 hover:text-white"
        title="Zoom out"
      >
        <ZoomOut size={18} />
      </button>
      <button
        onClick={onResetView}
        className="p-2 rounded-lg hover:bg-white/10 transition-colors text-zinc-400 hover:text-white"
        title="Reset view"
      >
        <Maximize2 size={18} />
      </button>

      {/* Snap to Grid */}
      <button
        onClick={onToggleSnap}
        className={`p-2 rounded-lg transition-colors ${
          snapToGrid 
            ? 'bg-purple-500/20 text-purple-400' 
            : 'hover:bg-white/10 text-zinc-400 hover:text-white'
        }`}
        title={snapToGrid ? 'Disable snap to grid' : 'Enable snap to grid'}
      >
        <Grid3X3 size={18} />
      </button>
    </div>
  );
};

export default MindMapToolbar;
